import { useCallback, useEffect } from 'react';
import { UseFieldArrayReplace, UseFormSetValue } from 'react-hook-form';

import { useQueryParams } from 'src/app/hooks/useQueryParams';
import { FunctionalityPageFormData } from 'src/features/Funnel/screens/FunnelPage/Functionality/FunctionalityPageScreen';

import { useTryToRequestFunctionalityPage } from './useTryToRequestFunctionalityPage';
import { useTryToRequestUpdateFunctionalityPage } from './useTryToRequestUpdateFunctionalityPage';

interface useRequestFunctionalityPageProps {
  setTitlePage: React.Dispatch<React.SetStateAction<string>>;
  titlePage: string;
  isUpdate: boolean;
  setIsUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  setValue: UseFormSetValue<FunctionalityPageFormData>;
  replace: UseFieldArrayReplace<FunctionalityPageFormData, 'slides'>;
}

export function useRequestFunctionalityPage({
  titlePage,
  setTitlePage,
  isUpdate,
  setIsUpdate,
  setValue,
  replace,
}: useRequestFunctionalityPageProps) {
  const params = useQueryParams();
  const pageId = params.get('pageId');

  const { tryToRequestFunctionality } = useTryToRequestFunctionalityPage();
  const { isLoadingFunctionalityUpdate, tryToRequestUpdateFunctionalityPage } =
    useTryToRequestUpdateFunctionalityPage();

  const handleUpdateFunctionalityPage = useCallback(
    async (e: FunctionalityPageFormData) => {
      await tryToRequestUpdateFunctionalityPage({
        id: pageId as string,
        payload: { name: titlePage, ...e },
      });
    },
    [titlePage, tryToRequestUpdateFunctionalityPage, pageId]
  );

  const handleRequestFunctionalityPage = useCallback(async () => {
    await tryToRequestFunctionality(pageId as string).then(response => {
      setValue('cancellationFunnelId', response.cancellationFunnelId);
      setValue(
        'continueCancelationButtonTitle',
        response.continueCancelationButtonTitle
      );
      setValue(
        'keepSubscriptionButtonTitle',
        response.keepSubscriptionButtonTitle
      );
      replace(response.slides);
      setTitlePage(response.name);
    });
  }, [tryToRequestFunctionality, setValue, setTitlePage]);

  useEffect(() => {
    if (pageId && !isUpdate) {
      handleRequestFunctionalityPage();
      setIsUpdate(true);
    }
  }, [pageId, isUpdate]);

  return { isLoadingFunctionalityUpdate, handleUpdateFunctionalityPage };
}
